import DynamicFaIcon from '../../atoms/DynamicFaIcon';
import { Link, useNavigate } from 'react-router-dom';

const BottomNavigation = () => {
	const navigate = useNavigate();

	return (
		<>
			<div className="buttom-navigation">
				<button
					onClick={() => navigate('/admin')}
					className="btn-block text-center"
				>
					<div className="flex justify-center text-[20px] mb-1">
						<DynamicFaIcon name={'FaHouseChimney'} />
					</div>
					<span className="mt-2">Home</span>
				</button>
				<button
					onClick={() => navigate('/admin/news')}
					className="btn-block mr-5 text-center"
				>
					<div className="flex justify-center text-[20px] mb-1">
						<DynamicFaIcon name={'FaNewspaper'} />
					</div>
					<span className="mt-2">News</span>
				</button>
				<button
					onClick={() => navigate('/admin/events')}
					className="btn-block ml-5 text-center"
				>
					<div className="flex justify-center text-[20px] mb-1">
						<DynamicFaIcon name={'FaCalendarDays'} />
					</div>
					<span className="mt-2">Event</span>
				</button>
				<button
					onClick={() => navigate('/admin/account')}
					className="btn-block text-center"
				>
					<div className="flex justify-center text-[20px] mb-1">
						<DynamicFaIcon name={'FaUserLarge'} />
					</div>
					<span className="mt-2">Account</span>
				</button>
				<button
					className="btn-block primary rounded-full !p-0 hover:opacity-80"
					onClick={() => navigate('/admin/qr')}
				>
					<div className="flex justify-center items-center text-[20px]">
						<img
							src="/assets/imgs/image-1383.svg"
							alt="image"
							className="p-0"
						/>
						{/* <DynamicFaIcon name={'FaPlay'} /> */}
					</div>
				</button>
			</div>
		</>
	);
};

export default BottomNavigation;
